import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';

import { COLORS, ROUTES, FONTS, device } from '../../../constants';

type ItemTypes = {
  title: string;
  path: string;
  onClick?: () => void;
  className?: string;
};

interface StyledLinkProps {
  $isContactUsPage: boolean;
}

export const NavItem = ({ title, path, onClick, className }: ItemTypes) => {
  const isContactUsPage = path === ROUTES.CONTACT_US;

  return (
    <StyledListItem>
      <StyledLink
        onClick={onClick}
        to={path}
        $isContactUsPage={isContactUsPage}
        className={className}
      >
        <Title>{title}</Title>
      </StyledLink>
    </StyledListItem>
  );
};

const StyledListItem = styled.li`
  list-style: none;
  height: 48px;
  display: flex;
  align-items: center;
  @media screen and ${device.md} {
    height: auto;
  }
`;

const Title = styled.h5`
  margin: 0;
  padding: 0;
  font-weight: 400;
  font-size: 1em;
  line-height: 27px;
  font-family: ${FONTS.SUBTITLE};
`;

const StyledLink = styled(Link)<StyledLinkProps>`
  text-decoration: none;
  color: ${({ $isContactUsPage }) =>
    $isContactUsPage ? COLORS.WHITE : COLORS.BLACK_TITLE};
  display: flex;
  align-items: center;
  border-bottom: 1px solid transparent;
  &:hover {
    color: ${({ $isContactUsPage }) =>
      $isContactUsPage ? COLORS.WHITE : COLORS.MAIN_RED};
    opacity: ${({ $isContactUsPage }) => ($isContactUsPage ? '0.85' : '1')};
  }
  background-color: ${({ $isContactUsPage }) =>
    $isContactUsPage ? COLORS.MAIN_RED : 'transparent'};
  padding: ${({ $isContactUsPage }) => ($isContactUsPage ? '0 28px' : '0')};
  box-sizing: border-box;
  height: ${({ $isContactUsPage }) => ($isContactUsPage ? '100%' : 'auto')};
  &.active {
    color: ${({ $isContactUsPage }) =>
      $isContactUsPage ? COLORS.WHITE : COLORS.MAIN_RED};
    border-color: ${({ $isContactUsPage }) =>
      $isContactUsPage ? 'transparent' : COLORS.MAIN_RED};
  }
  cursor: pointer;
  @media screen and ${device.md} {
    border-bottom: 0;
    border-left: 3px solid transparent;
    color: ${COLORS.BLACK};
    background-color: transparent;
    padding: 16px 24px;
    &.active {
      color: ${COLORS.MAIN_RED};
      border-color: ${COLORS.MAIN_RED};
    }
    &:hover {
      color: ${COLORS.MAIN_RED};
    }
  }
`;
